import React, { FC } from 'react'
import { cx } from 'class-variance-authority'
import { type Office } from './mapper'
import Wrapper from '../../ui/wrapper'
import { getOfficeAddress } from '../../../Utils/firm/office/address'

interface Props {
  offices: Office[]
  setFocusedAddress?: React.Dispatch<React.SetStateAction<{
    street: string;
    city: string;
    postalCode: string;
  } | null>>
  additionalClasses?: string
}

export const OfficesAddressesCard: FC<Props> = ({
  offices,
  setFocusedAddress = undefined,
  additionalClasses = undefined,
}) => {
  if (!offices || offices.length === 0) {
    return null
  }

  return (
    <Wrapper>
      <ul
        className={cx(
          'p-2 space-y-2 overflow-y-scroll no-scrollbar',
          additionalClasses,
        )}
      >
        <p className="text-lg font-semibold text-left text-night">
          Nos bureaux ({offices.length})
        </p>
        {offices.map((office) => (
          <li key={office?.uuid} title={office?.name ?? ''}>
            <button
              type="button"
              className="flex"
              onClick={() => {
                if (setFocusedAddress) {
                  setFocusedAddress({
                    longitude: office?.longitude ?? 0,
                    latitude: office?.latitude ?? 0,
                  })
                }
              }}
            >
              <span className="mr-2">📍</span>
              <p className="text-left text-night hover:underline">
                {getOfficeAddress(office)}
              </p>
            </button>
          </li>
        ))}
      </ul>
    </Wrapper>
  )
}
